jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined') {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_accesrapide');

    if (!blocs.length) {
        return;
    }

    var MOINS_DE_MOUVEMENT = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var DUREE = MOINS_DE_MOUVEMENT ? 0 : .55;
    var EASE = 'power3.out';

    var ECHELLE_INACTIF = .85;

    function initialiser(bloc) {
        var piste = bloc.querySelector('.images .piste');
        var liens = bloc.querySelectorAll('.liens .lien');

        if (!piste || !liens.length) {
            return;
        }

        var visuels = piste.querySelectorAll('.visuel');

        if (!visuels.length) {
            return;
        }

        // data-index compte les lignes sans image, pas la piste : sans
        // cette table les visuels se decalent des qu'une ligne n'en a pas
        var positions = {};

        Array.prototype.forEach.call(visuels, function (visuel, position) {
            positions[visuel.getAttribute('data-index')] = position;
        });

        // offsetTop et pas getBoundingClientRect : les visuels sont a
        // l'echelle reduite, une mesure rendue fausserait le pas
        function mesurerPas() {
            if (visuels.length < 2) {
                return 0;
            }

            return visuels[1].offsetTop - visuels[0].offsetTop;
        }

        var pas = mesurerPas();
        var courant = 0;

        gsap.set(visuels, {scale: ECHELLE_INACTIF});
        gsap.set(visuels[0], {scale: 1});
        gsap.set(piste, {y: 0});

        function activer(position) {
            if (position === courant) {
                return;
            }

            courant = position;

            var inactifs = Array.prototype.filter.call(visuels, function (visuel, i) {
                return i !== position;
            });

            gsap.to(piste, {
                y: -position * pas,
                duration: DUREE,
                ease: EASE
            });

            gsap.to(visuels[position], {
                scale: 1,
                duration: DUREE,
                ease: EASE
            });

            gsap.to(inactifs, {
                scale: ECHELLE_INACTIF,
                duration: DUREE,
                ease: EASE
            });
        }

        Array.prototype.forEach.call(liens, function (lien) {
            var position = positions[lien.getAttribute('data-index')];

            if (typeof position === 'undefined') {
                return;
            }

            function survol() {
                activer(position);
            }

            lien.addEventListener('mouseenter', survol);
            lien.addEventListener('focus', survol);
        });

        var recalcul = null;

        window.addEventListener('resize', function () {
            if (recalcul) {
                return;
            }

            recalcul = window.requestAnimationFrame(function () {
                recalcul = null;
                pas = mesurerPas();
                gsap.set(piste, {y: -courant * pas});
            });
        });
    }

    Array.prototype.forEach.call(blocs, initialiser);
});
